
var language = {
  // 中文
  1: {
    // 顶部内容
    top: {
      // 导航
      navs: [
        {path: "index",name: "首页"},
        {path: "about",name: "关于我们", children: [{path: "about",name: "公司介绍"}, {path: "joinUs",name: "加入我们"}]},
        {path: "owner/1",name: "主理人专区", children: [{path: "owner/2",name: "金牌主理人"}, {path: "owner/3",name: "品质主理人"}, {path: "ownerList",name: "深聊主理人"}]},
        {path: "medical",name: "产品中心", children: [{path: "medical",name: "专业院线"}, {path: "home",name: "家用产品线"}]},
        {path: "active",name: "对外活动"},
        {path: "search",name: "信息查验"},
      ],
    },
    // 底部内容
    foot: {
      // 导航
      navs: [
        {path: "/about",name: "关于我们"},
        {path: "/owner/2",name: "主理人专区", children: [{path: "owner/2",name: "金牌主理人"}, {path: "owner/3",name: "品质主理人"}, {path: "ownerList",name: "深聊主理人"}]},
        {path: "/medical",name: "产品中心", children: [{path: "medical",name: "专业院线"}, {path: "home",name: "家用产品线"}]},
        {path: "/active",name: "对外活动"},
        {path: "/search",name: "信息查验"},
      ],
      // 地址
      addr: "江苏省南京市溧水区东屏街道开屏路11号",
    },
  },
}

export default language;


// WEBPACK FOOTER //
// ./src/utils/language.js